import { render, staticRenderFns } from "./BlockPaymentPackageAdd.vue?vue&type=template&id=60f88db7&"
import script from "./BlockPaymentPackageAdd.vue?vue&type=script&lang=ts&"
export * from "./BlockPaymentPackageAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports